<ng-container *transloco="let t">
  <div class="ui-input">
    <label class="ui-label">Vista previa de factura</label>
    @if (numberToVouchersToGenerate() > 1) {
      <p class="ui-helper">
        {{
          t(
            'Seleccioná un pedido y revisá cómo se creará tu factura para corroborar los datos cargados.'
          )
        }}
      </p>
      <pxw-select-box
        name="selectedOrderDetails"
        [placeholder]="t('Seleccioná un pedido para visualizar su factura')"
        [options]="orderDetailsSelectorOptions()"
        [labelKey]="'label'"
        [valueKey]="'id'"
        [(ngModel)]="selectedOrderId"
      >
        <ng-template #selectedItemTemplate let-option>
          <div class="ui-input__input">
            <ng-container *ngTemplateOutlet="orderItemTemplate; context: { $implicit: option }" />
          </div>
        </ng-template>
        <ng-template #optionItemTemplate let-option>
          <ng-container *ngTemplateOutlet="orderItemTemplate; context: { $implicit: option }" />
        </ng-template>
      </pxw-select-box>
    } @else {
      <p class="ui-helper">
        {{ t('Revisá cómo se creará tu factura para corroborar los datos cargados.') }}
      </p>
    }
    <pxw-button
      color="yellow"
      size="sm"
      [rounded]="true"
      [loading]="generatingPreview()"
      (click)="onPreviewVoucher()"
    >
      <pxw-icon icon="eye" />
      Ver vista previa
    </pxw-button>
  </div>

  <ng-template #orderItemTemplate let-option>
    <strong style="font-family: monospace">{{ option.orderKey }}:</strong>
    <span>{{ option.orderKeyValue }}</span>
  </ng-template>

  @defer {
    <pxw-pdf-modal-viewer
      [(pdfPreviewSrc)]="pdfPreviewSrc"
      [title]="'Vista previa de factura'"
      [zoomIncrement]="0.1"
      [modalStyle]="'embeeded'"
      (error)="onError($event)"
    />
  }
</ng-container>
